import { useEffect, useRef, useCallback } from 'react'

const DEFAULT_TIMEOUT_MS = 5 * 60 * 1000

export function useInactivityTimer(onInactive: () => void, timeoutMs: number = DEFAULT_TIMEOUT_MS) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const onInactiveRef = useRef(onInactive)
  onInactiveRef.current = onInactive

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => onInactiveRef.current(), timeoutMs)
  }, [timeoutMs])

  useEffect(() => {
    const handleActivity = () => resetTimer()

    document.addEventListener('mousemove', handleActivity)
    document.addEventListener('click', handleActivity)
    document.addEventListener('keydown', handleActivity)
    document.addEventListener('scroll', handleActivity, true)

    resetTimer()

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      document.removeEventListener('mousemove', handleActivity)
      document.removeEventListener('click', handleActivity)
      document.removeEventListener('keydown', handleActivity)
      document.removeEventListener('scroll', handleActivity, true)
    }
  }, [resetTimer])
}
